export const SITE = {
  name: "Phillip",
  tagline: "Tax, bookkeeping & startup advisory for growing businesses",
  phoneDisplay: "(346) 535-6792",
  phoneHref: "tel:+13465356792",
  email: "pwood@cpafirm.site",
  location: "Houston, Texas",
  hours: "Mon–Fri · 9am–5pm CT",
};
